<script lang="ts">
    import { onMount } from "svelte"
    import Modal from "../../components/Modal.svelte"
    import { apiBaseOverride, isMobile, login } from "../../store"
    import Cta from "../../components/CTA.svelte"
    import { apiBaseURL } from "../../../config"

    export let field: TaskStepField<"signature">, value: FileField | null
    let showSignaturePad = false
    let canvas: HTMLCanvasElement
    let isDrawing = false
    let ctx: CanvasRenderingContext2D

    let lineColor = "#000000" // Standardfarbe: Schwarz
    let signatureSrc: string = ""
    let blobImgSrc = ""
    $: signatureSrc = resolveSignatureSrc(value)
    const taskId = typeof document !== "undefined" ? document.location.pathname.split("/").pop()?.split("?")[0] : ""
    async function downloadSecureSignature() {
        const file = resolveSignatureSrc(value)
        console.log("Downloading secure signature from", file)
        const res = await fetch("/api/task/68d18adeee42f8dce7494af3/signature/signature/src", {
            headers: { Authorization: `Bearer ${$login?.tokenString}` },
        })
        console.log(res)
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const blob = await res.blob()
        blobImgSrc = URL.createObjectURL(blob)
    }

    onMount(() => {
        ctx = canvas.getContext("2d")

        resizeCanvas()
        // Initiale Synchronisierung

        ctx.lineWidth = 2
        ctx.lineJoin = "round"
        ctx.lineCap = "round"

        // Resynchronisiere bei Fensteränderungen
        window.addEventListener("resize", resizeCanvas)
        console.log("value", value)
        if (signatureSrc.startsWith("/api")) {
            downloadSecureSignature().catch((err) => {
                console.error("Fehler beim Herunterladen der Signatur:", err)
            })
        }
        return () => {
            window.removeEventListener("resize", resizeCanvas)
        }
    })

    function resizeCanvas() {
        setTimeout(() => {
            /*
            const container = canvas.parentElement
            const rect = container.getBoundingClientRect()

            // Verhindere Versatz durch Skalierung:
            canvas.width = rect.width * devicePixelRatio // Physische Breite
            canvas.height = rect.height * devicePixelRatio // Physische Höhe
            console.log(canvas.width, canvas.height)
            // Skaliere den Zeichenkontext
            ctx.scale(devicePixelRatio, devicePixelRatio)*/
        }, 10)
    }

    function startDrawing(event: MouseEvent | TouchEvent) {
        isDrawing = true
        const { x, y } = getPosition(event)
        ctx.beginPath()
        ctx.moveTo(x, y)
    }

    function draw(event: MouseEvent | TouchEvent) {
        if (!isDrawing) return
        const { x, y } = getPosition(event)
        ctx.lineTo(x, y)
        ctx.strokeStyle = lineColor
        ctx.stroke()
    }

    function stopDrawing() {
        if (!isDrawing) return
        isDrawing = false
        ctx.closePath()
    }

    function clearCanvas() {
        ctx.clearRect(0, 0, canvas.width, canvas.height)
    }

    function saveSignature() {
        const resizedCanvas = document.createElement("canvas")
        const targetWidth = 300
        const targetHeight = 100
        resizedCanvas.width = targetWidth
        resizedCanvas.height = targetHeight

        const resizedCtx = resizedCanvas.getContext("2d")
        resizedCtx.fillStyle = "transparent"
        resizedCtx.fillRect(0, 0, targetWidth, targetHeight)

        const scaleX = targetWidth / canvas.width
        const scaleY = targetHeight / canvas.height
        const scale = Math.min(scaleX, scaleY) // Einheitliche Skalierung, damit nichts verzerrt wird
        const offsetX = (targetWidth - canvas.width * scale) / 2
        const offsetY = (targetHeight - canvas.height * scale) / 2

        // Zeichne die ursprüngliche Canvas-Zeichnung in das neue Canvas
        resizedCtx.drawImage(
            canvas,
            0,
            0,
            canvas.width,
            canvas.height,
            offsetX,
            offsetY,
            canvas.width * scale,
            canvas.height * scale
        )

        // Konvertiere das skalierte Canvas in einen Base64-String
        const dataURL = resizedCanvas.toDataURL("image/png")

        // Speichere das Bild als Base64
        value = {
            path: value?.path || "signature.png", // bisherigen Pfad beibehalten, falls vorhanden
            type: "image/png", // Typ
            size: (dataURL.length * 3) / 4, // Schätzungsweise Größe in Bytes
            src: dataURL, // Base64-String
        }
    }

    function getPosition(event: MouseEvent | TouchEvent) {
        const rect = canvas.getBoundingClientRect()

        let x: number, y: number

        if (event instanceof TouchEvent) {
            const touch = event.touches[0]
            x = (touch.clientX - rect.left) * (canvas.width / rect.width)
            y = (touch.clientY - rect.top) * (canvas.height / rect.height)
        } else if (event instanceof MouseEvent) {
            x = (event.clientX - rect.left) * (canvas.width / rect.width)
            y = (event.clientY - rect.top) * (canvas.height / rect.height)
        } else {
            x = 0
            y = 0
        }
        return { x, y }
    }

    function isAbsoluteSource(src: string) {
        return /^https?:\/\//i.test(src) || src.startsWith("data:") || src.startsWith("blob:")
    }

    function normalizePath(path?: string) {
        if (!path) return ""
        return path.replace(/^(\.\.\/)+/, "").replace(/^\/+/, "")
    }

    function resolveSignatureSrc(file?: FileField | null) {
        if (!file) return ""
        if (file.src && isAbsoluteSource(file.src)) return file.src
        if (file.path && isAbsoluteSource(file.path)) return file.path

        const baseUrl = ($apiBaseOverride ? $apiBaseOverride : apiBaseURL) || ""
        const candidate = normalizePath(file.path || file.src)

        if (!candidate) return ""

        if (/^(media|task|uploads|files)\//.test(candidate)) {
            return `${baseUrl}${candidate}`
        }

        if (taskId) {
            return `${baseUrl}task/${taskId}/${candidate}`
        }

        return `${baseUrl}${candidate}`
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
    class="image-row {!value ? 'smallOne' : ''}"
    on:click="{() => {
        resizeCanvas()
        showSignaturePad = true
    }}"
>
    <h3
        class="label"
        style="{!!value ? 'padding-bottom: 6px;' : ''}"
    >
        <img
            src="../../../assets/icons/solar_camera-outline.svg"
            alt="icon"
        />
        <p>Unterschrift</p>
    </h3>
    {#if value && signatureSrc}
        <div style="display: flex; gap: 1rem; justify-content: space-between;">
            {#if signatureSrc.startsWith("/api")}
                <p>Dieses Bild ist derzeit nicht darstellbar.</p>
            {:else}
                <img
                    style="height: 100px;"
                    src="{signatureSrc}"
                    alt="Unterschrift"
                />
            {/if}
            <button class="editImages">
                <img
                    src="../../../assets/icons/solar_refresh-bold.svg"
                    alt="icon"
                />
            </button>
        </div>
    {:else}
        <button class="editImages">
            <img
                src="../../../assets/icons/solar_pen-outline.svg"
                alt="icon"
            />
        </button>
    {/if}
</div>
<Modal
    bind:show="{showSignaturePad}"
    size="md"
    on:close="{() => {
        showSignaturePad = false
    }}"
>
    <h3
        slot="header"
        class="label"
    >
        <p>Unterschrift aufnehmen</p>
    </h3>
    <div>
        <p style="margin-bottom: 1.2rem;">
            Hiermit bestätigen sie, die Dienstleistung der Wohner GmbH in Anspruch genommen zu haben.<br /><br />
        </p>
        <div class="canvas-container">
            <canvas
                height="100"
                width="300"
                bind:this="{canvas}"
                on:mousedown="{startDrawing}"
                on:mousemove="{draw}"
                on:mouseup="{stopDrawing}"
                on:mouseleave="{stopDrawing}"
                on:touchstart="{startDrawing}"
                on:touchmove="{draw}"
                on:touchend="{stopDrawing}"></canvas>
        </div>
        <div
            class="button-group"
            style="display: flex; gap: 1rem;"
        >
            <Cta
                type="tertiaryButton"
                icon="solar_diskette-outline"
                content="{$isMobile ? '' : 'Speichern'}"
                on:click="{() => {
                    saveSignature()
                    showSignaturePad = false
                }}"
            />
            <Cta
                type="tertiaryButton"
                icon="solar_refresh-bold"
                content="{$isMobile ? '' : 'Löschen'}"
                on:click="{() => {
                    clearCanvas()
                }}"
            />
        </div>
    </div>
</Modal>

<style lang="less">
    .image-row {
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        padding: 0.6rem;
        border-radius: 12px;
        border: 1px solid var(--grey-200);
        background: var(--white-100);
        &.smallOne {
            flex-direction: row;
            justify-content: space-between;
            padding: 0px 0.6rem;
            cursor: pointer;
            .label {
                min-height: 54px;
            }
        }
    }
    h3.label {
        display: flex;
        gap: 0.6rem;
        align-items: center;
    }
    .canvas-container {
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        height: 120px;
        margin-bottom: 1.2rem;
        canvas {
            border: 1px dotted var(--grey-200);
            border-radius: 12px;
            cursor: crosshair;
            display: block; /* Entfernt unerwünschte Leerzeichen */
        }
    }
</style>
